import { Button, ButtonProps, useBreakpointValue, LinkProps, forwardRef } from '@chakra-ui/react';

interface IDownloadButtonProps extends ButtonProps, Pick<LinkProps, 'download'> {
  url: string;
}

export const DownloadButton = forwardRef<IDownloadButtonProps, 'button'>(({ as = 'a', url, ...rest }, ref) => {
  const variant = useBreakpointValue({ base: 'unstyled', md: 'outline' });

  return (
    <Button
      as={as}
      href={url}
      ref={ref}
      target="_blank"
      variant={variant}
      size="sm"
      w="max-content"
      minW="max-content"
      display="flex"
      justifyContent="space-between"
      {...rest}
    />
  );
});
